/**
 * @file 图片列表
 * @author FengGuang(fengguang01@baidu.com)
 */
import React, {useCallback} from 'react';
import copy from 'copy-text-to-clipboard';
import CopyBtn from '../copy-btn/CopyBtn';
import {IPictureList} from '../../types';

const PictureList: React.FC<IPictureList> = props => {
    const pictureGroup = props.pictureGroup || [];

    const handleOnCopy = useCallback((value?: string) => {
        copy(value || '');
    }, []);

    return (
        <div className="paddle-paddle-picture-list">
            {pictureGroup.map((item, index) => (
                <React.Fragment key={index}>
                    {
                        !!item.title
                        && <div className="paddle-paddle-page-h2">
                            {item.title}
                        </div>
                    }
                    {item.imgList.map((imgItem, index) => (
                        <div className="paddle-paddle-page-context" key={index}>
                            {!!item.copyText
                            && <CopyBtn onClick={() => handleOnCopy(item.copyText)} />
                            }
                            <img
                                className="paddle-paddle-picture-list-img"
                                alt={props.title}
                                src={imgItem}
                            />
                        </div>
                    ))}
                </React.Fragment>
            ))}
        </div>
    );
};

export default PictureList;
